var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center gap-2 wraningBorder flex-wrap text-black/88",
        },
        [
          _c(
            "div",
            { staticClass: "flex gap-2 items-center" },
            [
              _c("InfoCircleFilled"),
              _vm._v(
                "Visit check-ins open 10 minutes before the scheduled start time and are considered late if not completed within 5 minutes after that time. "
              ),
            ],
            1
          ),
        ]
      ),
      _c("p", { staticClass: "font-semibold mb-5 CompletedTasks titleTab" }, [
        _vm._v("Completed Visits"),
      ]),
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.isActivitiesLoaded, hasData: !_vm.isLoading } },
        [
          _c(
            "div",
            { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
            [
              _c(
                "FormGroup",
                [
                  _c("ContractorsMultiselect", {
                    attrs: {
                      value: _vm.contractorsIdsCompleted,
                      getParentcontainerStyle: "customWidthMax smallHeight",
                      placeholder: "Search by assignee",
                      contractorsConditions:
                        _vm.contractorsMultiselectConditions,
                      debounceTime: 1000,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateContractorsFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isEmpty && _vm.activitiesCompleted.length > 0
            ? [
                _c("div", { staticClass: "overflow-scroll" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "relative w-full text-sm font-normal text-left mt-6 dark:text-gray-400 tableParent",
                    },
                    [
                      _c(
                        "thead",
                        {
                          staticClass:
                            "text-m text-black customBackground CompletedBack",
                        },
                        [_c("TableHeaders")],
                        1
                      ),
                      _vm._l(_vm.activitiesCompleted, function (activity) {
                        return _c("ManagementActivityCard", {
                          key: activity.id,
                          attrs: {
                            activity: activity,
                            project: _vm.project,
                            redirectToContractor: true,
                            frozen: activity.project.completed,
                            currentUserId: _vm.currentUser.id,
                            currentUser: _vm.currentUser,
                            currentUserRole: _vm.currentUser.role,
                            companyId: _vm.companyId,
                          },
                          on: {
                            activityAdded: _vm.onActivityListItemsChanged,
                            activityDeleted: _vm.onActivityListItemsChanged,
                            activityUpdated: _vm.onActivityListItemsChanged,
                            activityCompleted: _vm.onActivityListItemsChanged,
                            activityCancelled: _vm.onActivityListItemsChanged,
                            activityReopened: _vm.onActivityListItemsChanged,
                          },
                        })
                      }),
                    ],
                    2
                  ),
                ]),
                _c("CardPagination", {
                  staticClass: "mt-4",
                  attrs: { config: _vm.paginationConfig },
                  on: {
                    "update:config": [
                      function ($event) {
                        _vm.paginationConfig = $event
                      },
                      function ($event) {
                        return _vm.handlePaginationEvent($event)
                      },
                    ],
                  },
                }),
              ]
            : [
                _c("EmptyListPlaceholder", {
                  attrs: { title: "You currently have no completed visits" },
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }